import React, { useState, useEffect, useRef, memo } from "react";
import DataGrid, {
  Column,
  Selection,
  RequiredRule,
  RangeRule,
  Pager,
  Editing,
  Lookup,
  PatternRule,
} from "devextreme-react/data-grid";
import { formatMessage } from "devextreme/localization";
import notify from "devextreme/ui/notify";
import { useScreenSize } from "../../utils/media-query";
// import "./style.scss";
import { axios } from "../../common/axios";

function ApprovalDataGridCommon({ approvalSelected }) {
  const { isXSmall, isSmall } = useScreenSize();
  const dataGridRef = useRef(null);
  const [employee, setEmployee] = useState([]);

  useEffect(() => {
    handleFetch();
  }, []);

  const handleFetch = async () => {
    try {
      const { data } = await axios.get("Employee", {
        params: {
          $filter: "DateOut eq null",
          $select: "Oid,EmployeeCode,FullName",
        },
        headers: {
          MappedState: 1,
        },
      });
      setEmployee(data.value);
    } catch (error) {
      notify(error);
    }
  };

  return (
    <div>
      <DataGrid
        showBorders={true}
        showRowLines={true}
        hoverStateEnabled={true}
        rowAlternationEnabled={true}
        columnResizingMode="widget"
        allowColumnResizing={true}
        width="100%"
        columnAutoWidth={true}
        columnHidingEnabled={true}
        alignment="center"
        ref={dataGridRef}
        dataSource={approvalSelected}
        className="datagrid-has-toolbar-actions ma-2 mt-0"
      >
        <Editing
          mode="form"
          allowUpdating={true}
          useIcons={true}
          allowAdding={true}
          allowDeleting={true}
        />

        <Selection
          mode="multiple"
          selectAllMode="page"
          showCheckBoxesMode="always"
        />
        <Pager
          showPageSizeSelector={true}
          allowedPageSizes={[5, 10, 20]}
          showInfo={true}
        />

        <Column
          caption="Level"
          dataField="ApprovalLevel"
          dataType="number"
          hidingPriority={isXSmall || isSmall ? 4 : false}
        >
          <RequiredRule />
          <RangeRule min={1} type="range" />
          <PatternRule
            message="Please enter a valid number"
            pattern={/^[0-9]+$/}
          />
        </Column>

        <Column
          caption={formatMessage("EmployeeCode")}
          dataField="Employee.Oid"
          allowSearch={true}
        >
          <RequiredRule />
          <Lookup
            dataSource={employee}
            valueExpr="Oid"
            displayExpr={(item) => `${item.EmployeeCode} - ${item.FullName}`}
          />
        </Column>
        {/* <Column
          caption={formatMessage("DepartmentName")}
          dataField="Department.DepartmentName"
          dataType="string"
          allowEditing={false}
          hidingPriority={isXSmall || isSmall ? 1 : false}
        />
        <Column
          caption={formatMessage("PositionName")}
          dataField="Position.PositionName"
          dataType="string"
          allowEditing={false}
          hidingPriority={isXSmall || isSmall ? 5 : false}
        />*/}
        <Column
          caption={formatMessage("Description")}
          dataField="Description"
          dataType="string"
          hidingPriority={isXSmall || isSmall ? 4 : false}
        />
      </DataGrid>
    </div>
  );
}
export default memo(ApprovalDataGridCommon);
